<div style="width: 98.5vw">
  <div class="form-row" style="margin: 0; padding-top: 5vh">
    <div class="col-lg-2"></div>
    <div class="col-lg-8">
      <div class="d-flex justify-content-center pt-2">
        <img
          alt="Gobierno de la Republica"
          src="./assets/img/mopc-home.png"
          height="80"
          loading="lazy"
        />
      </div>
      <div class="d-flex justify-content-center">
        <div
          class="container"
          style="text-align: justify; text-justify: inter-word"
        >
          <br />
          <div class="d-flex justify-content-center">
            <h4>
              SORTEO DE OBRAS VIALES Y DE EDIFICACION EN DISTINTAS PROVINCIAS
            </h4>
          </div>
          <p class="card-text">
            El Ministerio de Obras Públicas y Comunicaciones (MOPC) invita a las
            empresas <b>MIPYMES</b>, cuya actividad comercial sea de la
            construcción y personas naturales que sean
            <b>Ingenieros Civiles</b> o
            <b>Arquitectos (certificados como MIPYMES)</b>, que se encuentren
            debidamente registrados y al día en el Colegio Dominicano de
            Ingenieros, Arquitectos y Agrimensores (CODIA), para participar en
            el Sorteo de Obras Viales y Edificaciones, divididas en lotes, a
            ejecutarse en distintas provincias del País. <br /><br />
            Antes de llenar el formulario debe leer y aceptar el Pliego de
            Condiciones Específicas correspondiente al sorteo seleccionado.
            <br />
            <a
              href="https://www.mopc.gob.do/transparencia/compras-y-contrataciones/sorteos-de-obras/2020"
              target="_blank"
            >
              <b>(Link de pliego de Condiciones)</b>
            </a>
            <br />
            <br />
            Verifica aquí si cumples con los requisitos.
            <a target="_blank" routerLink="/verificate">
              <b>¡Verifícate!</b>
            </a>
            <br />
            <br />
            Consulta los ganadores de los sorteos pasados.
            <a target="_blank" routerLink="/ganadores-sorteo/pasados">
              <b>Aquí</b>
            </a>
          </p>
          <div class="form-row">
            <div class="col-12 col-lg-4">
              <button
                type="button"
                class="btn btn-primary float-left btn-block"
                routerLink="/participante/solicitud"
              >
                Crear solicitud
              </button>
            </div>
            <div class="col-12 col-lg-4 offset-lg-4">
              <button
                type="button"
                class="btn btn-success btn-block"
                routerLink="/login"
              >
                Iniciar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
